import {ActionWithPayload} from './index';
import {User, UserWithCountryCode} from '@models/user.interface';
import {AppState} from "@store/reducers/index";
import {createSelector} from "@ngrx/store";
import {selectPossibleCountries} from "@store/reducers/countries.reducer";
import {Card} from "@models/card.interface";
import {LOAD_USER, LOAD_USER_CARDS_SUCCESS, REMOVE_PROFILE} from "@store/actions";

export interface ProfileState {
  user: User;
  role: number;
  cards: Card[]
}

export function profileReducer(
  state = {
    user: null,
    role: null,
    cards: null
  }, action: ActionWithPayload<ProfileState>) {
  switch (action.type) {

    case LOAD_USER:
      return {
        ...state,
        user: action.payload.user,
        role: action.payload.user && action.payload.user.role
      };

    case REMOVE_PROFILE:
      return {
        user: null,
        role: null
      };

    case LOAD_USER_CARDS_SUCCESS:
      return {
        ...state,
        cards: action.payload.cards
      };

    default:
      return state;
  }
}

export const selectProfile = (state: AppState) => state.profile;

export const selectUser = createSelector(
  selectProfile,
  (state: ProfileState) => state.user
);

export const selectUserCards = createSelector(
  selectProfile,
  (state: ProfileState) => state.cards
);

export const selectUserData = createSelector(
  selectProfile,
  (state: ProfileState) => state.user && ({
    address: state.user.address,
    city: state.user.city,
    country_code: state.user.country_code,
    zip: state.user.zip,
  })
);

export const selectUserIsCompany = createSelector(
  selectUser,
  (state: User) => state.is_company
);


export const selectUserWithCountryCode = createSelector(
  selectUser,
  selectPossibleCountries,
  (selectedUser: User, countries: Array<{value: string, label: string}>) => {
    if (selectedUser && countries) {
      const country = countries.find(
        country => country.label === selectedUser.country || country.value === selectedUser.country
      );
      return <UserWithCountryCode>{
        ...selectedUser,
        country_code: country && country.value,
        country: country && country.label
      };
    } else {
      return <User>selectedUser;
    }
  }
);

export const selectDefaultPaymentData = createSelector(
  selectProfile,
  (({user, cards}) => {
    return {
      method: user.settings.default_payment_method,
      card: cards && cards.find(data => !!data.is_default),
    };
  })
);

export const selectDefaultInsurance = createSelector(
  selectProfile,
  (({user}) => {
    return user.settings.insurance_selected_default;
  })
);



// WEBPACK FOOTER //
// ./src/app/store/reducers/profile.reducer.ts